import type { OrderDTO } from 'ecosystem'
import { createLogger } from 'shared-utils'
import {
  fetchPropsFactory,
  storefrontApiCall,
  urlWithQueryParamsFactory
} from '../../utils/fetching'
import { ORDERS_ENDPOINT } from './constants'

export interface GetStorefrontOrderParams {
  paymentId?: string
  orderNumber?: string
}

const logger = createLogger('storefront-api/orders')

export async function getStorefrontOrderByOrderNumber(params: GetStorefrontOrderParams) {
  const url = urlWithQueryParamsFactory<GetStorefrontOrderParams>(`${ORDERS_ENDPOINT}/`, {
    queryParams: params
  })
  const props = fetchPropsFactory({
    props: {
      method: 'GET',
      credentials: 'include'
    }
  })

  logger.log('getStorefrontOrderByOrderNumber [REQ]', { url, params })

  const result = await storefrontApiCall<OrderDTO>(url, props)

  if (result.error) {
    logger.error('getStorefrontOrderByOrderNumber [ERROR]', {
      url,
      params,
      error: result.error
    })
  } else {
    logger.log('getStorefrontOrderByOrderNumber [RES]', { url, data: result.data })
  }

  return result
}
